module.exports = __webpack_public_path__ + "img/145.ba00a657.jpg";